module.exports = __webpack_public_path__ + "static/media/asx.8a33ec25.png";